import { render, staticRenderFns } from "./tabTargetGroupInstances.vue?vue&type=template&id=58f91db6&"
import script from "./tabTargetGroupInstances.vue?vue&type=script&lang=js&"
export * from "./tabTargetGroupInstances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports